import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { TooltipPosition, TooltipComponent as MatTooltipComponent } from '@angular/material/tooltip'

MatTooltipComponent.prototype._markForCheck = function () {
  if (!this._changeDetectorRef['destroyed']) {
    this._changeDetectorRef.detectChanges()
  }
}

@Component({
  selector: 'lin-tooltip',
  template: `
    <div
      [matTooltipClass]="{ 'below-tooltip': belowTooltip, 'lin-tooltip': true }"
      matTooltipPosition="{{ tooltipPosition }}"
      matTooltip="{{ label }}"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TooltipComponent implements OnInit {
  @Input() label: string
  @Input() tooltipPosition: TooltipPosition = 'above'
  belowTooltip = false

  ngOnInit() {
    this.belowTooltip = this.tooltipPosition === 'below'
  }
}
